<template>
  <FilterTypeDate fromType="startDateFrom" toType="startDateTo" />
</template>

<script>
import FilterTypeDate from "./FilterTypeDate.vue";
export default {
  name: "StartDateFilter",
  components: { FilterTypeDate },
};
</script>

<style>
</style>